export default __webpack_public_path__ + "static/media/products2.774c5a88.svg";